var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-follow-up"},_vm._l((_vm.botFollowUp),function(text,index){return _c('div',{key:index,staticClass:"message-follow-up-item"},[_c('div',{staticClass:"follow-up-body",on:{"click":function($event){return _vm.followUpClick(text)}}},[_c('div',{staticClass:"follow-up-body-text"},[_vm._v(_vm._s(text))])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c5285e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/im/right/chat/ChatMessageFollowUp.vue
// module id = null
// module chunks = 